import React from 'react';

const TONES = {
  success: { text: 'var(--status-success-text)', bg: 'var(--status-success-bg)' },
  warning: { text: 'var(--status-warning-text)', bg: 'var(--status-warning-bg)' },
  danger: { text: 'var(--status-danger-text)', bg: 'var(--status-danger-bg)' },
  info: { text: 'var(--status-info-text)', bg: 'var(--status-info-bg)' },
  neutral: { text: 'var(--status-neutral-text)', bg: 'var(--status-neutral-bg)' },
};

export function StatusPill({ tone = 'neutral', children, dot = true }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: '6px', height: '24px', padding: '0 10px',
      borderRadius: 'var(--radius-pill)', fontSize: 'var(--fs-caption)', fontWeight: 500,
      color: t.text, background: t.bg, whiteSpace: 'nowrap',
    }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: t.text }} />}
      {children}
    </span>
  );
}
